
import { createAction, props } from '@ngrx/store';

//
export const resetPaginate = createAction('[LISTPROJECTS] Inicia paginador');

//
export const setCurrentPage = createAction('[LISTPROJECTS] Set actual página', props<{ page: number }>());

//
export const setCurrentFilter = createAction('[LISTPROJECTS] Set actual filtro', props<{ filter: number }>());